<template>
  <div>
    <tables :config="config()" />
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    props: {
      detail: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        list: []
      }
    },
    components: {
      tables: () => import(/* webpackPrefetch: true */ '@/components/basic/table.vue')
    },
    watch: {
      
    },
    computed: {
      
    },
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch () {
        let params = {
          sort: 'DESC'
        }

        this.list = []

        await get('jenis_ajuan', { params })
        .then(response => {
          let res = response.data

          if (res.code === 200) {
            let data = res.data

            data.map((obj) => {
              this.list.push({
                text: obj.ja_judul,
                value: obj.ja_id
              })
            })
          }
        })
      },
      config () {
        return {
          // CONFIG PARSING API
          api: `admin/ajuan/${this.detail.layanan_kode}`,

          // SINGLE
          single: true,

          // CHECKBOX
          checkbox: true,

          // PADDING
          padding: 'py-0',

          // HEIGHT
          height: true,

          // CONFIG PARSING HEADER
          header: [
            {
              text: '#No',
              width: '75px',
              value: 'index',
              sortable: false,
              freeze: true,
              hide: false,
              align: 'center'
            },
            {
              text: 'No. Reg',
              width: '200px',
              value: 'ajuan_no_reg',
              freeze: true,
              hide: false
            },
            {
              text: 'Kode Layanan',
              width: '200px',
              value: 'ajuan_layanan_kode',
              freeze: false,
              hide: false,
              format: 'regex'
            },
            {
              text: 'Jenis Ajuan',
              width: '400px',
              value: 'ja_judul',
              freeze: false,
              hide: false
            },
            {
              text: 'Jalur Online / Offline',
              width: '200px',
              value: 'ajuan_is_online',
              freeze: false,
              hide: false,
              format: 'on_off'
            },
            // {
            //   text: 'Pelapor',
            //   width: '200px',
            //   value: 'ajuan_is_mandiri',
            //   freeze: false,
            //   hide: false,
            //   format: 'g_m'
            // },
            {
              text: 'Pelapor',
              width: '200px',
              value: 'ajuan_pelapor_role_name',
              freeze: false,
              hide: false
            },
            {
              text: 'Status',
              width: '200px',
              value: 'ajuan_status',
              freeze: false,
              hide: false
            },
            {
              text: 'Tanggal',
              width: '200px',
              value: 'ajuan_create_datetime',
              freeze: false,
              hide: false,
              format: 'datetime'
            }
          ],

          // CONFIG PARSING FILTER
          filter: [
            {
              field: 'ajuan_no_reg',
              label: 'No. Reg',
              type: 'text',
              placeholder: 'Contoh. KK-20220812000004',
              value: '',
              width: '55%',
              required: false
            },
            {
              field: 'ajuan_jenis_ajuan_id',
              label: 'Kode Layanan',
              type: 'select',
              placeholder: 'Contoh. PERGANTIAN KARTU HILANG',
              value: '',
              option: this.list,
              width: '70%',
              required: false
            },
            {
              field: 'ajuan_status',
              label: 'Status',
              type: 'select',
              placeholder: 'Contoh. DISETUJUI',
              value: '',
              option: ['BELUM DIVERIFIKASI', 'PROSES VERIFIKASI', 'DISETUJUI', 'DISETUJUI TANPA NIK', 'DISETUJUI TERBIT NIK', 'PROSES INPUT NIK', 'DITOLAK', 'DIKOREKSI', 'SELESAI DIPROSES'],
              width: '60%',
              required: false
            },
            {
              field: 'ajuan_create_datetime',
              label: 'Tanggal',
              type: 'date',
              placeholder: 'Contoh. 2021-12-13',
              value: '',
              picker: false,
              width: '40%',
              required: false
            }
          ],

          // PREFIX KEY
          prefix: '',

          // CONFIG PARSING FORM
          form: [],

          // CONFIG PARSING ACTION
          action: {
            tab: {
              button: false,
              api: [],
              field: ''
            },
            filter: {
              button: true,
              api: ''
            },
            add: {
              button: false,
              api: '',
              window: false,
              href: ''
            },
            edit: {
              button: false,
              api: '',
              window: false,
              href: ''
            },
            delete: {
              button: false,
              api: ''
            },
            detail: {
              button: true,
              api: '/submission/akm/'
            },
            reject: {
              button: false,
              api: ''
            },
            approve: {
              button: false,
              api: ''
            },
            print: {
              button: false,
              api: ''
            },
            freeze: {
              button: true,
              api: ''
            },
            hide: {
              button: false,
              api: ''
            }
          }
        }
      }
    }
  }
</script>